import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Create Update Mrf Service */
const createUpdateMrf = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.mrf.createUpdateMrf}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/* Get Interviewer List Service*/
const getInterviewerList = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.mrf.getInterviewerList}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/*Get Mrf Data By Id Service */
const getMrfDataById = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.mrf.getMrfDataById}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/*Submit Draft Mrf Service */
const submitDraftMrf = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.mrf.submitDraftMrf}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/* Get All UserMrf Service */
const getAllUserMrf = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.mrf.getAllUserMrf}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/* Get Mrf Dashboard And Hierarchy Service */
const getMrfDashboardAndHierarchy = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.mrf.getMrfDashboardAndHierarchy}`,
    method: "GET",
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};

/* Get Mrf For Approval Data Service */
const getMrfForApprovalData = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.mrf.getMrfForApproval}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};


/* Approve Reject Mrf Data Service */
const approveRejectMrfData = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.mrf.approveRejectMrf}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error?.response?.data);
    });
  return response;
};





export default {
  createUpdateMrf,
  getInterviewerList,
  getMrfDataById,
  submitDraftMrf,
  getAllUserMrf,
  getMrfDashboardAndHierarchy,
  getMrfForApprovalData,
  approveRejectMrfData,
}